<template>
  <drag-zone class="horizontal-zone">
    <drag-content class="horizontal-zone--content horiozontal-zone--frame-side"
      :style="(borderClickFlag ? 'width: 64px !important; min-width: 0px;' : '' ) + (sideBorderResizeFlag && !borderClickFlag ?  'width: 320px !important' : '')">
      <aside>
        <div class="category-group">
          <article>
            <h1>{{selectedMenu.menuName}}</h1>
          </article>
          <slot name="sideContent" />
        </div>
        <slot name="sideFooter" />
      </aside>
    </drag-content>
    <drag-handle ref="dragHandle" @on-click-drag-handle="onClickDragHandle(borderClickFlag)" :class="'horizontal-zone--handle ' + (sideBorderResizeFlag ? ' mouse-hover-border' : '')"></drag-handle>
    <drag-content id="page-wrapper" class="page horizontal-zone--content horiozontal-zone--frame-main" :style="(sideBorderResizeFlag ? `width: calc(100% - ${sideWidth}px) !important;` : '')">
      <div class="page-container">
        <slot name="mainTitle"/>
        <slot name="mainContent" />
      </div>
    </drag-content>
  </drag-zone>
</template>

<script>
import DragZone from '@/components/external/VueDragZone/zone';
import DragHandle from '@/components/external/VueDragZone/handle';
import DragContent from '@/components/external/VueDragZone/content';

export default {
  name: 'WMainTemplate',
  components: {
    DragZone,
    DragHandle,
    DragContent,
  },
  props: {
    // 좌측 프레임 border 클릭 시 감춤기능 제공 flag
    sideBorderResizeFlag: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      sideWidth: 310, // 좌측 프레임 고정 width 값
      borderClickFlag: false, // 좌측 프레임 마우스 오버 후 해당 border 클릭 flag
    };
  },
  computed: {
    selectedMenu() {
      return this.$store.getters.selectedMenu;
    },
  },
  methods: {
    /**
     * [56000 - 일감]
     * 이벤트 메뉴에서 좌측 프레임(트리)를 숨길 수 있는 버튼, 기능 추가 - 이벤트 메뉴에서 resize 기능을 막고 마우스 오버 시 border를 클릭하여 좌측 프레임을 제어할 수 있도록 기능 추가하였음
     * resize를 이용하여 늘리고 줄일 수 있도록 구현하였으나 drag-content, drag-handle이 계산되어 나오는 고정 width이므로 resize 후 윈도우창 resize(확대, 축소)시에 깨짐 현상 발생
     * 이에 따라 '이벤트 메뉴'에서는 좌측 프레임 border 클릭 시 프레임 축소, 확대 되도록 기능 수정변경 (2020.04.02)
     * @author Song
     */
    onClickDragHandle(value) {
      // 좌측 프레임 border 클릭 시 감춤기능 제공 화면에만 적용
      if (this.sideBorderResizeFlag) {
        this.borderClickFlag = !value;
        this.sideWidth = value ? '310' : '0';
      }
    },
  },
};
</script>

<style>
.mouse-hover-border {
  z-index: 10;
  width: 11px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  cursor: pointer !important;
}
.mouse-hover-border:hover {
  border-right: 8px solid #ddd !important;
}
</style>



// WEBPACK FOOTER //
// src/components/template/MainTemplate.vue